import type { BuiltDifferentlyData } from "types/compare";
import React from "react";
import Image from "next/image";

interface BuiltDifferentlyComparisonProps {
    builtDifferentlyData: BuiltDifferentlyData;
}

const BuiltDifferentlyComparison: React.FC<BuiltDifferentlyComparisonProps> = ({ builtDifferentlyData }) => {
    return (
        <section className="py-16 px-5" style={{ background: "linear-gradient(103.32deg, #EDF4FF 28.71%, #D2DDFF 84.45%, #84A2FF 136.43%)" }}>
            <h2 className="text-4xl md:text-6xl font-semibold mb-12 text-center" style={{ fontFamily: "Degular Display" }}>
                {builtDifferentlyData.sectionTitle}
            </h2>
            <div className="max-w-7xl mx-auto">
                {builtDifferentlyData.comparisonBlocks.map((block, idx) => (
                    <div key={idx} className="mb-12">
                        <h3 className="text-2xl font-bold mb-6 text-gray-900 text-center font-inter">{block.title}</h3>
                        <div className="flex gap-4 md:flex-row flex-col">
                            <div
                                className="bg-white rounded-xl shadow-md p-5 flex items-start gap-3 w-full"
                                style={{
                                    border: "1.15px solid var(--colors-gray-300, rgba(203, 213, 224, 1))",
                                    boxShadow: "0px 22.96px 27.56px -4.59px rgba(16, 24, 40, 0.08), 0px 9.19px 9.19px -4.59px rgba(16, 24, 40, 0.03)",
                                }}
                            >
                                <Image src="/gallabox-icon.png" alt="Gallabox" width={34} height={40} className="flex-shrink-0" />
                                <p className="text-black font-inter text-xl leading-relaxed">{block.gallabox}</p>
                            </div>
                            <div
                                className="bg-white rounded-xl shadow-md p-5 flex flex-row-reverse md:flex-row items-start  gap-3 w-full  relative"
                                style={{
                                    border: "1.15px solid var(--colors-gray-300, rgba(203, 213, 224, 1))",
                                    boxShadow: "0px 22.96px 27.56px -4.59px rgba(16, 24, 40, 0.08), 0px 9.19px 9.19px -4.59px rgba(16, 24, 40, 0.03)",
                                }}
                            >
                                <div
                                    className="absolute -top-7 left-1/2 right-1/2 md:-left-7 md:top-1/3 flex items-center justify-center flex-shrink-0 w-10 h-10 rounded-full text-white text-sm font-medium mx-auto md:mx-0"
                                    style={{
                                        background: "linear-gradient(123.9deg, #3364FA 9.72%, #00E785 96.53%)",
                                    }}
                                >
                                    vs
                                </div>
                                <p className="text-black font-inter text-xl leading-relaxed flex-1">{block.competitor}</p>
                                <Image
                                    src={builtDifferentlyData.competitorLogo}
                                    alt={`${builtDifferentlyData.competitorName} logo`}
                                    width={48}
                                    height={48}
                                    className="flex-shrink-0"
                                />
                            </div>
                        </div>
                        <div
                            className="bg-white mt-5 border border-blue-200 rounded-xl shadow-md p-5 flex items-center gap-3"
                            style={{
                                border: "1px solid var(--colors-brand-500, rgba(0, 131, 255, 1))",
                                background: "var(--colors-brand-100, rgba(204, 230, 255, 1))",
                                boxShadow: "0px 22.96px 27.56px -4.59px rgba(16, 24, 40, 0.08), 0px 9.19px 9.19px -4.59px rgba(16, 24, 40, 0.03)",
                            }}
                        >
                            <Image src="https://assets.gallabox.com/gb-home/compare/double-start-blue-icon.svg" alt="star icon" width={27} height={27} />

                            <p className="text-black font-inter text-xl leading-relaxed ">
                                <span className="font-bold">Impact:</span> {block.impact}
                            </p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default BuiltDifferentlyComparison;
